// What needs the person on Home (02-DESIGN/03-console/01-the-console.md § the
// shape; § conventions: the moves, page by page — Home): at most five lines,
// the most urgent first, and *Show all* with the count beyond them.

import type { Tone } from "../../ui/components.tsx";

/** SHOWN is how many lines *Needs you* shows before *Show all*. */
export const SHOWN = 5;

/** Need is one line of *Needs you*: a thing that waits for the person, and where it is. */
export interface Need {
  key: string;
  tone: Tone;
  text: string;
  sub: string;
  to: string;
  /** The navigation state the link carries: the tab the page opens on, `{ tab }`. */
  state?: { tab: string };
  /** How urgent it is: lower first. A failing workload, then a request waiting, then the rest. */
  rank: number;
}

/** Rank orders the kinds of need, most urgent first. The plan's line follows a failing workload. */
export const Rank = {
  failing: 0,
  plan: 1,
  request: 2,
  recovery: 3,
  waiting: 4,
} as const;

/** urgentFirst is the needs in order of urgency, each kind in the order it was read. */
export function urgentFirst(needs: readonly Need[]): Need[] {
  return needs
    .map((n, i) => ({ n, i }))
    .sort((a, b) => a.n.rank - b.n.rank || a.i - b.i)
    .map((x) => x.n);
}

/** split is the lines *Needs you* shows, and the rest, which *Show all* opens in place, under them. */
export function split(needs: readonly Need[]): { shown: Need[]; beyond: number } {
  const ordered = urgentFirst(needs);
  return { shown: ordered.slice(0, SHOWN), beyond: Math.max(ordered.length - SHOWN, 0) };
}
